















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ChangeHeaders extends Vue {
  @Prop({ default: [] }) headers!: Record<string, any>[];

  didClickRow(header: Record<string, any>): void {
    if (header.active) {
      this.$emit("disable", header.value);
    } else {
      this.$emit("enable", header.value);
    }
  }
}
